TS.ns('TS.domain.properties.fields');

/**
 * @class TS.domain.properties.fields.RadioGroupListField
 * @extends TS.domain.properties.fields.SelectionListField
 */
TS.domain.properties.fields.RadioGroupListField = new Class(
    /** @lends TS.domain.properties.fields.RadioGroupListField# */
    {
        Extends: TS.domain.properties.fields.SelectionListField,

        initialize: function (owner, config) {
            var me = this;
            me.parent(owner, config);
        }
    });

TS.domain.properties.ListField.types['radiogroup'] = TS.domain.properties.fields.RadioGroupListField;
